module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_ZNB_ChapterTextStyle__And__No_Hyphenation__And__Centre_Alignment"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "'Bell MT'",
      "font-size": "4.80em"
    }
  }, [_vm._v("DRAGONESQUE")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357a2f82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0001.vue
// module id = 60
// module chunks = 0